import { appConfig } from "config/initializers/config.app";

/*
 * Actions
 */
export const FETCH_ALL_COUPONS = "FETCH_ALL_COUPONS";
/*
 * Action Creators
 */

function _getList(status, err, data) {
    return {
        type: FETCH_ALL_COUPONS,
        status,
        err,
        data,
    };
}

const getUserCouponsList = (userId) => {
    return (dispatch, getState, Request) => {
        let getUserCouponsListPath = appConfig.endpoints.getUserCouponsListPath.replace(":id", userId);
        return Request.fetch(getUserCouponsListPath, {
            method: "GET",
        }).then((response) => {
            return response.json().then((data) => {
                return Promise.resolve(
                    dispatch(_getList("success", null, data))
                );
            });
        })
            .catch((err) => {
                console.log(err);
            });
    };
};

class CouponsAction {
    static getUserCouponsList = getUserCouponsList;
}

export { CouponsAction };
